import { render, staticRenderFns } from "./ResidentMappingPcc.vue?vue&type=template&id=2f28673d"
import script from "./ResidentMappingPcc.vue?vue&type=script&lang=js"
export * from "./ResidentMappingPcc.vue?vue&type=script&lang=js"
import style0 from "./ResidentMappingPcc.vue?vue&type=style&index=0&id=2f28673d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports